var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"intersect",staticClass:"intersection-observer"},[_c('div',{staticClass:"intersection-observer-inner blur"},[_vm._t("default",[_c('h2',[_vm._v("Step "+_vm._s(_vm.step)+" – "+_vm._s(_vm.step + _vm.stepSize))])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }